import chevironRight from "$/cheviron-right.svg";
// import { ContractTreeChildren } from "@/business/contract/ContractTreeChildren";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import MessageModal from "@/MessageModal";
import useOpenModal from "^/common/useOpenModal";
import { Dialog } from "@/Dialog";
import { useState } from "react";
import { useBusinessWithdrawal } from "~/services/auth";
import { signOutForOAuth, unlinkForOAuth, setForceRelogin } from "#/auth/signIn";
import { useStorage } from "^/common/useStorage";
import { SignType } from "#/unique/domain";
import { usePlatform } from "^/common/usePlatform";
import { useBusinessAnnouncementUnreadCount } from "~/services/business/announcement";
import {
  useBusinessMypageDisconnectCompany,
  useBusinessMypageMenu,
} from "~/services/business/myPage";

export const Route = createFileRoute("/business/layout/user-teacher-setting")({
  component: UserSetting,
});

function UserSetting() {
  const { history } = useRouter();
  const { isOpenModal, clickModal, closeModal } = useOpenModal();
  const [sns] = useStorage<SignType>("local-sign-sns-type");
  const [isWithdrawalConfirmVisible, setIsWithdrawalConfirmVisible] =
    useState(false);
  const [isWithdrawalCompleteVisible, setIsWithdrawalCompleteVisible] =
    useState(false);
  // const [contractMenuOpen, setContractMenuOpen] = useState(false);
  const { data: announcementUnread } = useBusinessAnnouncementUnreadCount();
  const announcementUnreadCount = announcementUnread?.count ?? 0;

  const { mutate: withdrawal } = useBusinessWithdrawal();
  const { mutate: disconnectCompany, isPending: isDisconnecting } =
    useBusinessMypageDisconnectCompany();
  const { data: menuList } = useBusinessMypageMenu();
  const { isApp, isAppIOS, isAppAndroid } = usePlatform();

  const businessSettingMenus = [
    { label: "서비스 통계", to: "/business/layout/user-service-statistics" },
    { label: "고객 정보 목록", to: "/business/layout/user-customer-management" },
    // 선생님은 원장처럼 트리로 펼치지 않고 계약 현황 화면으로 바로 이동한다.
    { label: "계약 관리", to: "/business/layout/contract-status" },
    {
      label: "영업시간 관리",
      to: "/business/layout/user-business-time-management",
    },
    {
      label: "사업장 사진 등록",
      to: "/business/layout/user-business-photo-management",
    },
    { label: "이용권 관리", to: "/business/layout/user-subscription-management" },
    {
      label: "이용권 발급 내역",
      to: "/business/layout/user-subscription-issue-history",
    },
  ] as const;

  const permittedBusinessSettingMenus = businessSettingMenus.filter((m) =>
    Array.isArray(menuList) ? menuList.includes(m.label) : false
  );

  const handleWithdrawalConfirmOpen = () => {
    setIsWithdrawalConfirmVisible(true);
  };

  const handleDisconnectCompany = () => {
    disconnectCompany(undefined, {
      onSuccess: (data: any) => {
        if (data.statusCode === "200") {
          console.log("회사 연결 해제 성공:", data);
          closeModal();
          // teacher 화면으로 이동
          history.push("/business/layout/teacher");
        }
      },
      onError: (error: any) => {
        console.error("회사 연결 해제 실패:", error);
        // 에러 처리 (토스트 메시지 등)
      },
    });
  };

  const handleWithdrawalConfirmClose = () => {
    setIsWithdrawalConfirmVisible(false);
  };

  const handleWithdrawalCompleteClose = () => {
    setIsWithdrawalCompleteVisible(false);
    handleAfterWithdrawal();
  };

  const handleWithdrawalConfirm = () => {
    setIsWithdrawalConfirmVisible(false);

    withdrawal(undefined, {
      onSuccess: (response) => {
        console.log("회원탈퇴 성공:", response);
        setIsWithdrawalCompleteVisible(true);
        handleAfterWithdrawal();
      },
      onError: (error) => {
        console.error("회원탈퇴 실패:", error);
        // 에러 처리 (필요시 토스트 메시지 등)
      },
    });
  };

  const getSnsTypeForBridge = () => {
    if (sns === "SNS_TYPE_KAKAO") return "kakao";
    if (sns === "SNS_TYPE_GOOGLE") return "google";
    if (sns === "SNS_TYPE_APPLE") return "apple";
    if (sns === "SNS_TYPE_NAVER") return "naver";
    return "";
  };

  const clearLocalSession = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("local-sns-id");
    localStorage.removeItem("local-sign-sns-type");
    localStorage.removeItem("session-fcm");
    sessionStorage.removeItem("session-sign-sns-type");
  };

  const handleLogout = async () => {
    const snsType = getSnsTypeForBridge();
    console.log("[business/teacher-setting] 로그아웃", { sns, snsType, isApp });

    if (isApp) {
      if (isAppAndroid) {
        window.mung.appLoginOut(snsType);
      } else if (isAppIOS) {
        window.webkit?.messageHandlers?.mung?.postMessage([
          "appLoginOut",
          snsType,
        ]);
      }
    } else {
      // 웹: SNS OAuth 로그아웃
      try {
        await signOutForOAuth();
      } catch (error) {
        console.error("OAuth 로그아웃 실패:", error);
      }
    }

    clearLocalSession();
    setForceRelogin(); // 다음 로그인 시 SNS 로그인 화면 강제 표시
    history.push("/");
  };

  /** 회원탈퇴 후 처리 — SNS 권한까지 끊기 */
  const handleAfterWithdrawal = async () => {
    const snsType = getSnsTypeForBridge();
    console.log("[business/teacher-setting] 회원탈퇴 후 SNS 연결 끊기", { sns, snsType, isApp });

    if (isApp) {
      if (isAppAndroid && typeof window.mung?.appUnlink === "function") {
        window.mung.appUnlink(snsType);
      } else if (isAppAndroid) {
        window.mung.appLoginOut(snsType);
      } else if (isAppIOS) {
        window.webkit?.messageHandlers?.mung?.postMessage([
          "appUnlink",
          snsType,
        ]);
      }
    } else {
      try {
        await unlinkForOAuth();
      } catch (error) {
        console.error("SNS 연결 끊기 실패:", error);
      }
    }

    clearLocalSession();
    history.push("/");
  };

  // console.log(mypageMain)
  return (
    <>
      <LayoutHeader title={"설정"} hasBackBtn hasFootPrint={false} />
      <div className="flex-auto px-3 pt-5 bg-[#F5F5F5]">
        <div className="bg-[#F5F5F5]">
          {/* 사용자 설정 */}
          <div>
            <div className="mb-2 font-medium">서비스 설정</div>
            <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
              <button
                className="flex justify-between items-center px-4 py-2 w-full"
                onClick={() =>
                  history.push("/business/layout/user-teacher-push")
                }
              >
                <span>알림 설정</span>
                <img src={chevironRight} alt="알림" />
              </button>
            </div>
          </div>

          {/* 사업자 설정 메뉴 (권한 기반 노출) */}
          {permittedBusinessSettingMenus.length > 0 && (
            <div className="mt-4">
              <div className="mb-2 font-medium">사업자 설정</div>
              <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
                {permittedBusinessSettingMenus.map((m) =>
                  // m.label === "계약 관리" ? (
                  //   <div key={m.label}>
                  //     <button
                  //       className="flex justify-between items-center px-4 py-2 w-full"
                  //       onClick={() => setContractMenuOpen((v) => !v)}
                  //     >
                  //       <span>계약 관리</span>
                  //       <span
                  //         className={`text-[#BDBDBD] text-[12px] transition-transform ${
                  //           contractMenuOpen ? "rotate-90" : ""
                  //         }`}
                  //       >
                  //         ▶
                  //       </span>
                  //     </button>
                  //     {contractMenuOpen && (
                  //       <ContractTreeChildren history={history} />
                  //     )}
                  //   </div>
                  // ) : (
                    <button
                      key={m.label}
                      className="flex justify-between items-center px-4 py-2 w-full"
                      onClick={() => history.push(m.to)}
                    >
                      <span>{m.label}</span>
                      <img src={chevironRight} alt={m.label} />
                    </button>
                  // )
                )}
              </div>
            </div>
          )}
          <div className="mt-4">
            <div className="mb-2 font-medium">계정 설정</div>
            <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
              <button
                className="flex justify-between items-center px-4 py-2 w-full"
                onClick={() =>
                  history.push("/business/layout/user-teacher-info")
                }
              >
                <span>회원 정보 관리</span>
                <img src={chevironRight} alt="회원 정보 관리" />
              </button>
            </div>
          </div>

          {/* 사업자 연동 */}
          <div className="mt-4">
            <div className="mb-2 font-medium">사업자 연동</div>
            <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
              <button
                className="flex justify-between items-center px-4 py-3 w-full"
                onClick={() => clickModal()}
              >
                <span>사업자 연동 해제</span>
                <img src={chevironRight} alt="사업자 연동 해제" />
              </button>
            </div>
          </div>
          {/* 시스템 정보 */}
          <div className="mt-4">
            <div className="mb-2 font-medium">시스템 정보</div>
            <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
              <button
                className="flex justify-between items-center px-4 py-3 w-full"
                onClick={() => history.push("/business/layout/user-owner-announcement")}
              >
                <span>공지사항</span>
                <div className="flex items-center gap-2">
                  {announcementUnreadCount > 0 && (
                    <span className="inline-flex items-center justify-center min-w-[20px] h-[20px] px-1.5 rounded-full bg-red-500 text-white text-[11px] font-semibold">
                      {announcementUnreadCount > 99
                        ? "99+"
                        : announcementUnreadCount}
                    </span>
                  )}
                  <img src={chevironRight} alt="공지사항" />
                </div>
              </button>
              <button
                className="flex justify-between items-center px-4 py-3 w-full"
                onClick={() => history.push("/policy" as any)}
              >
                <span>약관 및 정책</span>
                <img src={chevironRight} alt="약관 및 정책" />
              </button>
            </div>
          </div>
          <MessageModal
            isOpen={isOpenModal}
            onRequestClose={closeModal}
            className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none"
            overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
            shouldCloseOnOverlayClick={false}
          >
            <div className="flex flex-col gap-1">
              <div className="flex flex-col mb-2">
                <div className="text-lg font-semibold text-center">
                  사업자 연동 해제
                </div>
              </div>
              <div className="flex flex-col mb-2">
                <div className="text-sm text-center text-[#666666]">
                  사업장 연동 해제 이후에는 다른 사업장 등록 전까지
                </div>
                <div className="text-sm text-center text-[#666666]">
                  더이상 서비스를 이용하실 수 없습니다.
                </div>
              </div>
              <div className="flex gap-3 mt-2">
                <button
                  className="flex-1 py-2 font-semibold text-gray-600 bg-gray-200 rounded-full"
                  onClick={closeModal}
                  disabled={isDisconnecting}
                >
                  취소
                </button>
                <button
                  className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full disabled:opacity-50"
                  onClick={handleDisconnectCompany}
                  disabled={isDisconnecting}
                >
                  {isDisconnecting ? "처리중..." : "확인"}
                </button>
              </div>
            </div>
          </MessageModal>

          {/* 회원탈퇴 확인 모달 */}
          <Dialog
            visible={isWithdrawalConfirmVisible}
            onClose={handleWithdrawalConfirmClose}
            persist={false}
          >
            <div className="flex flex-col gap-1">
              <div className="flex flex-col mb-2">
                <div className="text-lg font-semibold text-center">
                  회원 탈퇴
                </div>
              </div>
              <div className="flex flex-col mb-2">
                <div className="text-sm text-center text-[#666666]">
                  회원 탈퇴 시 모든 개인정보 및 사업자 정보를
                </div>
                <div className="text-sm text-center text-[#666666]">
                  더이상 확인하실 수 없으며, 정산정보가 삭제됩니다.
                </div>
                <div className="text-sm text-center text-[#666666] mt-2">
                  탈퇴 후에는 삭제된 정보를 복구할 수 없습니다.
                </div>
              </div>
              <div className="flex gap-3 mt-2">
                <button
                  className="flex-1 py-2 font-semibold text-gray-600 border border-[#E5E5E5] rounded-full"
                  onClick={handleWithdrawalConfirmClose}
                >
                  취소
                </button>
                <button
                  className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
                  onClick={handleWithdrawalConfirm}
                >
                  확인
                </button>
              </div>
            </div>
          </Dialog>

          {/* 회원탈퇴 완료 모달 */}
          <Dialog
            visible={isWithdrawalCompleteVisible}
            onClose={handleWithdrawalCompleteClose}
            persist={false}
          >
            <div className="flex flex-col gap-1">
              <div className="flex flex-col mb-2">
                <div className="text-lg font-semibold text-center">
                  회원 탈퇴
                </div>
              </div>
              <div className="flex flex-col mb-2">
                <div className="text-sm text-center text-[#666666]">
                  회원 탈퇴가 완료되었습니다.
                </div>
              </div>
              <div className="flex gap-3 mt-2">
                <button
                  className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
                  onClick={handleWithdrawalCompleteClose}
                >
                  확인
                </button>
              </div>
            </div>
          </Dialog>

          {/* 로그아웃 */}
          <div className="flex justify-between px-4 pb-4 mt-10">
            <button
              className="text-sm text-gray-400 text-[#666666]"
              onClick={() => handleLogout()}
            >
              로그아웃
            </button>
            <button
              className="text-sm text-gray-400 text-[#666666]"
              onClick={handleWithdrawalConfirmOpen}
            >
              회원탈퇴
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
